import script from "./AffiliatePartnerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AffiliatePartnerModal.vue?vue&type=script&setup=true&lang=js"

import "./AffiliatePartnerModal.vue?vue&type=style&index=0&id=629f7053&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-629f7053"]])

export default __exports__